module.exports = require('./dist/echarts-amap.min.js')



//////////////////
// WEBPACK FOOTER
// ./~/_echarts-amap@1.0.0-rc.6@echarts-amap/index.js
// module id = 856
// module chunks = 128